module.exports = __webpack_public_path__ + "img/share-like.8e4e443.svg";